module.exports = __webpack_public_path__ + "static/media/front.63c29462.jpg";